declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

function track(event: string, source: string) {
  if (typeof window === "undefined") return;

  window.fbq?.("track", event, {
    source,
  });
}

export function trackLead(source: string) {
  track("Lead", source);
}

export function trackViewContent(source: string) {
  track("ViewContent", source);
}

export function trackContact(source: string) {
  track("Contact", source);
}
